import { render, staticRenderFns } from "./JobPageTags.vue?vue&type=template&id=21c3117e&scoped=true&"
import script from "./JobPageTags.vue?vue&type=script&lang=js&"
export * from "./JobPageTags.vue?vue&type=script&lang=js&"
import style0 from "./JobPageTags.vue?vue&type=style&index=0&id=21c3117e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3117e",
  null
  
)

export default component.exports